import * as phone from 'libphonenumber-js';
import * as yup from 'yup';

export const validatePhone = (value?: string | null) => {
  if (!value) return true;
  try {
    return phone.parsePhoneNumber(value).isValid();
  } catch (error: any) {
    return false;
  }
};

export const validateCIF = (input?: string | null) => {
  if (!input || input.length !== 9) return false;
  const inputChars = input.toUpperCase().split('');
  let sum = 0;
  for (let i = 1; i < 8; i++) {
    if (i % 2 === 0) {
      sum += parseInt(inputChars[i]);
    } else {
      sum += (parseInt(inputChars[i]) * 2)
        .toString()
        .split('')
        .reduce((sum, el) => sum + parseInt(el), 0);
    }
  }
  const result = (10 - (sum % 10)) % 10;
  const control = parseInt(inputChars[8]);
  if (isNaN(control)) {
    return String.fromCharCode(64 + result) === inputChars[8];
  }
  return control === parseInt(inputChars[8]);
};

export const validateNIF = (input?: string | null) => {
  if (!input || input.length !== 9) return false;
  const validChars = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const nifReg = new RegExp(`^[0-9]{8}[${validChars}]$`, 'i');
  const nieReg = new RegExp(`^[XYZ][0-9]{7}[${validChars}]$`, 'i');
  const str = input.toUpperCase();
  if (!nifReg.test(str) && !nieReg.test(str)) return false;
  const nie = str.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');
  const letter = str.substr(-1);
  const charIndex = parseInt(nie.substr(0, 8)) % 23;
  return validChars.charAt(charIndex) === letter;
};

export const validateCommaSeparatedEmails = (value?: string | null): boolean => {
  if (!value) return true; // Allow empty string
  const emails = value.split(/\s*,\s*/).filter(Boolean);
  if (emails.length === 0) return true; // Allow string with only commas/spaces

  const emailSchema = yup.string().email();

  return emails.every((email: string) => emailSchema.isValidSync(email));
};

// Regex for IPv4 validation
const ipv4Regex =
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const validateCommaOrNewlineSeparatedIPs = (value?: string | null): boolean => {
  if (!value) return true; // Allow empty string
  // Split by comma or newline, trimming whitespace
  const ips = value.split(/[\s*,\s*\n]+/).filter(Boolean);
  if (ips.length === 0) return true; // Allow string with only separators/spaces

  return ips.every((ip: string) => ipv4Regex.test(ip));
};

// Regex for domain validation
const domainRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]{1,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

export const validateCommaOrNewlineSeparatedDomains = (value?: string | null): boolean => {
  if (!value) return true; // Allow empty string
  // Split by comma or newline, trimming whitespace
  const domains = value.split(/[\s*,\s*\n]+/).filter(Boolean);
  if (domains.length === 0) return true; // Allow string with only separators/spaces

  return domains.every((domain: string) => domainRegex.test(domain));
};
